<template>
  <span :class="['base-input-wrapper']">
    <input :class="['base-input']" v-model="value" :placeholder="name" />
    <span class="base-input-title">{{ name }}</span>
  </span>
</template>

<script>
import _ from "lodash";

export default {
  name: "BaseInput",
  props: {
    name: String,
  },
  data: function () {
    return {
      value: "",
      showTitle: false,
    };
  },
  watch: {
    value: _.debounce(function () {
      this.$emit("update:value", this.value);
    }, 500),
  }
};
</script>

<style lang="scss">
.base-input-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;

  .base-input-title {
    color: $blueDark;
    position: absolute;
    top: -1.75rem;
    left: 2.1rem;

    font-weight: 600;
    visibility: visible;
  }

  .base-input {
    padding: 1rem 2rem;
    font-size: 1.25rem;
    font-weight: 200;

    border: 1px solid #707070;
    border-radius: $defaultBorderRadius;

    display: flex;
    align-items: baseline;
    position: relative;
    cursor: pointer;
    color: $blueDark;

    min-width: 20rem;
    width: 100%;

    text-align: left;
    box-sizing: border-box;

    @media screen and (max-width: 26rem) {
      font-size: 1rem;
      padding: .5rem 1rem;
    }

    &:focus {
      outline: 0;
    }

    &::placeholder {
      color: $blueDark;
    }
    &:placeholder-shown + .base-input-title {
      visibility: hidden;
    }
  }

}
</style>
